<template>
<div>
	<ul class="timeline-list">
		<li v-for="(day,index) in timeline" 
			:title="day.blockDate" 
			class="timeline-day"
			:class="{
				'filler-day' : day.fillerDay,
				'timeline-start' : index == 0,
				'timeline-end' : index == selectedHourBlocks.length - 1
			}"
			v-on:click="dayClick(index)">

			<template v-if="!day.fillerDay && day.events.length > 0">
				<i class="fa fa-circle" ></i>
				<span>{{ moment(day.blockDate).format("MM-DD") }}</span>
			</template>	
		</li>
	</ul>

	<div v-if="selectedDay && selectedHourBlocks">
		<div class="d-flex justify-content-between">
			<h4>{{ selectedDay }}</h4>
			<i class="fa fa-times icon-button" v-on:click="selectedDay = false"></i>
		</div>

		<ul class="timeline-list">
			<li v-for="(block,index) in selectedHourBlocks" 
				:title="blockIndexToTimeLabel(block.block)" 
				class="timeline-block" 
				:class="{
					'timeline-start' : index == 0,
					'timeline-end' : index == selectedHourBlocks.length - 1
				}"
				v-on:click="blockClick(index)">

				<i class="fa fa-circle" v-if="block.blockEvents.length > 0"></i>
				<span>{{ blockIndexToTimeLabel(block.block) }}</span>
			</li>
		</ul>

		<table-list v-if="selectedDay"
			record-name="Event"
			:fields="[
				{label: '', key: 'typeIcon'},
				{label: 'Date/Time', key: 'dateTimeFormatted'},
				{label: 'Event', key: 'description'}
			]"
			:records="mutatedBlockEvents">

			<h4>{{ selectedDay }} <template v-if="selectedHour">{{ blockIndexToTimeLabel(selectedHour) }}</template></h4>

		</table-list>
	</div>
</div>
</template>

<script type="text/javascript">

import TableList from "@/components/TableList"

export default {
	name: "EquipmentTimeline",
	props: ["timelineEvents"],
	components: {
		TableList
	},
	data() {
		return {
			selectedDay: null,
			selectedHourBlocks: [],
			selectedHour: null,
			selectedHourEvents: []
		}
	},
	computed: {
		timelineStart() {

		},
		timeline() {
			let vm = this

			let dailyBlocks = []

			let jobKey = "service_id"
			if (this.jobType == 'project')
				jobKey = "job_id"

			let timelineStartDay = this.moment(this.getEarliestDate(this.timelineEvents))

			let today = vm.moment().add(1,"days")

			for (var m = timelineStartDay; m.isSameOrBefore(today); m.add(1,"days")) {
				let events = vm.timelineEvents.filter(event =>
					vm.moment(event.dateTime).format("YYYY-MM-DD") === m.format("YYYY-MM-DD")
				).sort((a, b) =>
					vm.moment(a.dateTime).isAfter(vm.moment(b.dateTime)) ? 1 : -1
				);

				dailyBlocks.push({
					blockDate: m.format("YYYY-MM-DD"),
					events,
					fillerDay: false
				})

			}

			let condensed = dailyBlocks.filter((day,index) => {
				if (day.events.length > 0)
					return true
			})

			let mutated = [], nextDay
			condensed.forEach((day,index) => {
				if (index <= condensed.length - 2)
					nextDay = condensed[index + 1]

				if (index == 0 && vm.moment(day.blockDate).isAfter(timelineStartDay)) {
					mutated.push({
						blockDate: timelineStartDay.format("YYYY-MM-DD"),
						events: [],
						fillerDay: true
					})

				}
				mutated.push(day)

				if (nextDay && vm.moment(nextDay.blockDate).diff(vm.moment(day.blockDate),"days") > 1) {
					mutated.push(
						{
							blockDate: vm.moment(day.blockDate).add(1,"days").format("YYYY-MM-DD"),
							events: [],
							fillerDay: true
						}
					)
				}
			})

			/*
			if (mutated.length > 0 && this.moment(mutated[mutated.length - 1].blockDate).isBefore(this.moment())) {
				mutated.push(
					{
						blockDate: vm.moment().format("YYYY-MM-DD"),
						events: [],
						fillerDay: true
					}
				)
			}
			*/

			return mutated
		
		},
		mutatedBlockEvents() {

			function mutateEvent(event) {
				event.dateTimeFormatted = ""

				if ("dateTime" in event)
					event.dateTimeFormatted = vm.formatDateTimeToLocal(event.dateTime)
			

				event.typeIcon = ""
				if (event.type == 'TimeLog')
					event.typeIcon = "<i class='fa fa-clock'></i>"
				else if (event.type == 'Equipment')
					event.typeIcon =  "<i class='fa fa-truck'></i>"

				return event
			}

			let vm = this
			if (!this.selectedHour && this.selectedDay) {
				let selectedDay = this.timeline.find(day => day.blockDate == this.selectedDay)

				if (selectedDay)
					return selectedDay.events.map(event => mutateEvent(event))
				else
					return []
			}
			else if (this.selectedHour) {
				return this.selectedHourEvents.map(event => mutateEvent(event))
			}
			else return []
		}
	},	
	methods: {
		dayClick(index) {
			if (this.timeline[index].events.length > 0) {
				this.selectedDay = this.timeline[index].blockDate
				this.selectedHourBlocks = this.hourlyTimelineBlocks(this.timeline[index])
				this.selectedHour = null
			}
		},
		blockClick(index) {
			this.selectedHour = this.selectedHourBlocks[index].block
			this.selectedHourEvents = this.selectedHourBlocks[index].blockEvents
		},
		hourlyTimelineBlocks(events) {
			let vm = this, hourBlocks = []

			if (events && "events" in events) {
				for (var block = 0; block < 24 * 4; block++) {
					let blockEvents = []
					events.events.forEach(event => {

						let eventTimeBlockEquivalent

						let hour = +vm.moment.utc(event.dateTime).local().format("H")
						let minute = +vm.moment.utc(event.dateTime).local().format("m")

						let minuteBlock
						if (minute < 15)
							minuteBlock = 0
						else if (minute < 30)
							minuteBlock = 1
						else if (minute < 45)
							minuteBlock = 2
						else
							minuteBlock = 3

						eventTimeBlockEquivalent = (hour * 4) + minuteBlock

						if (block == eventTimeBlockEquivalent) {

							blockEvents.push({
								description: event.description,
								type: event.type,
								dateTime: event.dateTime
							})
						}
					})

					hourBlocks.push({
						block,
						blockEvents
					})
				}
			}
			return hourBlocks
		},
		blockIndexToTimeLabel(index) {
			let hour = Math.floor(index / 4)

			let remainder = index % 4
			let minutes = ""

			if (remainder == 0)
				minutes = ":00"
			else if (remainder == 1)
				minutes = ":15"
			else if (remainder == 2)
				minutes = ":30"
			else if (remainder == 3)
				minutes = ":45"

			return hour + minutes
		},
		noEventsBeforeOrAfter(index) {
			if (index == 0 || index == this.timeline.length - 1)
				return false

			if (this.timeline[index - 1].events.length == 0 && this.timeline[index + 1].events.length == 0 && this.timeline[index].events.length == 0)
				return true

			return false
		},
		getEarliestDate(data) {
			if (!Array.isArray(data) || data.length === 0) return null;

				return data.reduce((earliest, current) => {
					const currentDate = new Date(current.dateTime);
					const earliestDate = new Date(earliest.dateTime);
					return currentDate < earliestDate ? current : earliest;
				});
		}
		
	},
	created() {

	}
}
</script>

<style scoped>
	.timeline-list {
		list-style: none;
		padding: 0;
		display: flex;
		flex-wrap: wrap;

	}

	.timeline-list li {
		display: inline-block;
		cursor: pointer;
		margin-left: -1px;
		margin-right: -1px;
		position: relative;
		min-width: 50px;
		height: 40px;
		margin: 0;
		padding: 1px;
		padding-left: 0;
		padding-right: 0;
		border-top: 3px solid black;
		position: relative;
		text-align: center;
		flex-grow: 1;
	}

	.timeline-list li.timeline-day.filler-day {
		border-top: 3px dotted black;
	}

	.timeline-list li.timeline-start {
		border-left: 3px solid black;
	}

	.timeline-list li.timeline-end {
		border-right: 3px solid black;
	}

	.timeline-list .line {
		height: 3px;
		width: 100%;
		background-color: black;
		position: relative;
	}

	.timeline-list li:hover {
		color: var(--brand-primary-color);
		border-color: var(--brand-primary-color);
		background-color: var(--brand-primary-color-faded);
	}

	.timeline-list li:hover .line {
		background-color: var(--brand-primary-color);
		color: var(--brand-primary-color);
	}

	.timeline-list li .fa-minus {
		text-align: center;
	}

	.timeline-list li .fa-circle {
		position: absolute;
		top: -8px;
		left: 0;
		right: 0;
		width: 15px;
		margin: auto;
		color: var(--brand-primary-color);
	}

	.timeline-list .timeline-day,
	.timeline-list .timeline-block {
		vertical-align: top;
		padding: 5px;
	}

	.timeline-list .timeline-block span {
		text-align: center;
	}

	.timeline-list li .fa-ellipsis-h {
		position: relative;
		top: -5px;
		width: 30px;
		text-align: center;
	}

	.timeline-list .timeline-block span {
		color: inherit;
		top: 15px;
		left: 7px;
	}

	.timeline-list li .timeline-block span {

	}
</style>